import React from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const isAuthenticated = localStorage.getItem("auth") === "true";
  const profilePic = localStorage.getItem("profilePic");
  const navigate = useNavigate();

  const handleAccountClick = () => {
    // Get user type from localStorage
    const userType = localStorage.getItem("userType");
    console.log("aaa",userType);

    // Redirect according to user type
    if (userType === "Admin") {
      navigate("/admin");
    } else if (userType === "Company Admin") {
      navigate("/user");
    } else {
      // Optionally handle unknown type (redirect to login or default)
      navigate("/login");
    }
  };

  const handleSignIn = () => {
    navigate("/login");
  };

  const handleSignUp = () => {
    navigate("/signup");
  };

  return (
    <header style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 30px',
      background: '#f5f5f5'
    }}>
      <span>
        <img src="/assets/images/s.png" alt="" height="50" />
      </span>
      {/* <nav>
        {!isAuthenticated ? (
          <>
            <button className="btn btn-success mx-2" onClick={handleSignIn}>Sign In</button>
            <button className="btn btn-primary mx-2" onClick={handleSignUp}>Sign Up</button>
          </>
        ) : (
          <button
            className="btn btn-outline-Primary mx-2"
            onClick={handleAccountClick}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={profilePic || "/assets/images/s.png"}
              alt="Profile"
              height="32"
              style={{ borderRadius: "30%", marginRight: "8px" }}
            />
            My Account
          </button>
        )}
      </nav> */}
    </header>
  );
};

export default Header;